module.exports = __webpack_public_path__ + "static/img/img_form2_ja.1cbfd27f.png";